class VideoWrapper extends HTMLElement {
  connectedCallback() {
    this.videoOverlay = this.querySelector('.video-overlay');
    this.video = this.querySelector('video');

    this.initOverlay = this.initOverlay.bind(this);
    this.initOverlay();
  }

  initOverlay() {
    if (!this.videoOverlay) return;

    this.videoOverlay.addEventListener('click', () => {
      this.videoOverlay.style.display = 'none';
      this.video.play();
    });
  }
}

if (!customElements.get('video-wrapper')) {
  customElements.define('video-wrapper', VideoWrapper);
}